"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviourModel = void 0;
class BehaviourModel {
    constructor(dateTimeModifier, cache) {
        this.setBehaviourDay = async (customerId, day) => this.cache
            .setObject(this.behaviourDayKey(customerId, day.date), day)
            .asPromise();
        this.getBehaviourDay = async (customerId, date) => {
            return this.cache
                .getObject(this.behaviourDayKey(customerId, date))
                .withDefault({
                date,
                isDone: null,
                lessonOrdinalNumber: null,
                lessonTitle: null,
                memberAnswer: {},
                lessonDescription: null,
            })
                .asPromise();
        };
        this.getBehaviourDateRange = async (customerId, dateRange) => {
            let date = this.dateTimeModifier.modifyDays(dateRange.from, -1);
            const days = [];
            while (date !== dateRange.to) {
                date = this.dateTimeModifier.modifyDays(date, 1);
                days.push(await this.getBehaviourDay(customerId, date));
            }
            return days;
        };
        this.behaviourDayKey = (customerId, date) => `${BehaviourModel.BEHAVIOUR_DAY_DB_PREFIX}.${customerId}.${date}`;
        this.dateTimeModifier = dateTimeModifier;
        this.cache = cache;
    }
}
exports.BehaviourModel = BehaviourModel;
BehaviourModel.BEHAVIOUR_DAY_DB_PREFIX = "Mock.Database.BEHAVIOUR_DAY_DB";
exports.default = BehaviourModel;
//# sourceMappingURL=BehaviourModel.js.map